import { render, staticRenderFns } from "./CustomKIMCard.vue?vue&type=template&id=bd574ba4&scoped=true"
import script from "./CustomKIMCard.vue?vue&type=script&lang=js"
export * from "./CustomKIMCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd574ba4",
  null
  
)

export default component.exports